import { useMemo } from 'react';

import { Icon } from '@/components/Icon';

import { mergeClassNames } from '@/utils';
import { getBatteryZone } from '@/utils/getBatteryZone';

import styles from './SensorCard.module.css';

interface SensorCardNotCalibratedProps {
  batteryLevel: number;
}

export const SensorCardNotCalibrated = ({ batteryLevel }: SensorCardNotCalibratedProps) => {
  const batteryZone = useMemo(() => getBatteryZone(batteryLevel), [batteryLevel]);

  return (
    <div className={mergeClassNames(styles.batteryIndicator, styles[batteryZone])}>
      <Icon
        name={
          {
            high: 'batteryFull' as const,
            medium: 'batteryWarning' as const,
            low: 'batteryCritical' as const,
          }[batteryZone]
        }
      />
      {batteryLevel}%
    </div>
  );
};
